import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, Gauge, LifeBuoy, ArrowRight } from 'lucide-react';
import { whyChoose } from '../mock/mock';

const iconMap = { Shield, Zap, Gauge, LifeBuoy };

const WhyChoose = () => {
  return (
    <section className="section-padding section-dark">
      <div className="container-x relative">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="eyebrow mb-4"><span className="w-1.5 h-1.5 rounded-full bg-cyan-400" /> What We Do</div>
          <h2 className="section-title">Why Choose <span className="gradient-text">Our Services?</span></h2>
          <p className="section-subtitle mx-auto mt-4">Enterprise-grade infrastructure designed to keep your business running smoothly, 24×7.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyChoose.map((item, i) => {
            const Icon = iconMap[item.icon] || Shield;
            return (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                whileHover={{ y: -6 }}
                className="relative p-6 rounded-2xl glass hover:border-cyan-400/40 transition-all group overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-cyan-500/10 rounded-full blur-3xl group-hover:bg-cyan-500/20 transition-all" />
                <div className="relative">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-500 to-purple-600 flex items-center justify-center mb-4 shadow-lg shadow-cyan-500/25 group-hover:scale-110 transition-transform">
                    <Icon className="text-white" size={24} />
                  </div>
                  <h3 className="text-lg font-bold text-white">{item.title}</h3>
                  <div className="flex items-baseline gap-2 mt-2">
                    <span className="text-2xl font-extrabold gradient-text">{item.metric}</span>
                    <span className="text-xs text-slate-400">{item.label}</span>
                  </div>
                  <p className="mt-3 text-sm text-slate-400 leading-relaxed">{item.description}</p>
                  <a href="#services" className="mt-4 inline-flex items-center gap-1 text-cyan-300 text-sm font-semibold hover:gap-2 transition-all">
                    Learn More <ArrowRight size={14} />
                  </a>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
